import { ReactElement, useEffect, useState } from "react";
import { Container } from "reactstrap";
import Table from "@components/Table";
import ModalConfirmation from "@components/ModalConfirmation";
import Loader from "@components/Loader";
import { useTranslation } from "react-i18next";
import useListColumns from "@hooks/Clients/Hackatao/mainAvatars/useListColumns";
import useDeleteItem from "@hooks/Shared/useDeleteItem";
import deleteItem from "@services/Clients/Hackatao/mainAvatars/deleteItem";
import { EUiStates } from "@constants/enum";
import Title from "@components/Title";
import CreateBtn from "@components/CreateButton";
import useListItems from "@hooks/Shared/useListItems";
import getItem from "@services/Clients/Hackatao/mainAvatars/getItem";
import listMainAvatarsMapper from "@mappers/Clients/Hackatao/mainAvatars/ListMainAvatars.mapper";

const ListItems = (): ReactElement => {
  const { t } = useTranslation(["core"]);
  const [isDeletingItem, setIsDeletingItem] = useState(false);
  const { isLoading, basicData, tableItems } = useListItems(
    isDeletingItem,
    getItem,
    listMainAvatarsMapper
  );
  const { isModalOpen, isDeleting, handleDelete, handleIsModalOpen } =
    useDeleteItem(basicData);
  const COLUMNS = useListColumns();

  useEffect(() => {
    setIsDeletingItem(isDeleting);
  }, [isDeleting]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <Container>
      <ModalConfirmation
        icon="trash"
        title={`${t("hackatao:common.mainAvatars")} | ${t(
          "core:common.delete_confirm"
        )}`}
        body={`${t("core:notifications.delete_message")} "${
          basicData?.description
        }" ?`}
        handleConfirm={() => {
          handleDelete(deleteItem);
        }}
        handleModalStatus={handleIsModalOpen}
        modalStatus={isModalOpen}
        modalType={EUiStates.DANGER}
      />

      <Title />
      <CreateBtn />
      <Table columns={COLUMNS} items={tableItems} />
    </Container>
  );
};

export default ListItems;
